import { css } from "@compiled/react";

import { SignupBackgroundLayout } from "@/components/signup/layouts";
import SiteActivation, {
    ExistingUser
} from "@/components/signup/site-activation";
import { RovoDevAgentsLogo } from "@/components/signup/utils";

import { PrivacyPolicy, WelcomeBackHeading } from "../../components";
import { SignupFormWithPaymentSwitcher } from "../../components/payment";

const headerCss = css({
    margin: 0,
    textAlign: "center"
});

export const LoggedInRovoDevStandardExistingSitesUser = () => {
    return (
        <SignupBackgroundLayout
            theme="green"
            ProductLogo={<RovoDevAgentsLogo />}
        >
            <SiteActivation
                ExistingUser={
                    <SignupFormWithPaymentSwitcher
                        header={
                            <h1 css={headerCss}>
                                <WelcomeBackHeading />
                            </h1>
                        }
                    >
                        <ExistingUser PrivacyPolicy={<PrivacyPolicy />} />
                    </SignupFormWithPaymentSwitcher>
                }
                WeekOneUser={null}
                ManagedUser={null}
            />
        </SignupBackgroundLayout>
    );
};
